import { render, staticRenderFns } from "./EditDiagnosis.vue?vue&type=template&id=2aa94b43&"
import script from "./EditDiagnosis.vue?vue&type=script&lang=ts&"
export * from "./EditDiagnosis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa94b43')) {
      api.createRecord('2aa94b43', component.options)
    } else {
      api.reload('2aa94b43', component.options)
    }
    module.hot.accept("./EditDiagnosis.vue?vue&type=template&id=2aa94b43&", function () {
      api.rerender('2aa94b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/EditDiagnosis.vue"
export default component.exports